import { render, staticRenderFns } from "./ActHistoryStep.vue?vue&type=template&id=61afe79d&"
import script from "./ActHistoryStep.vue?vue&type=script&lang=ts&"
export * from "./ActHistoryStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
